import { useState, useEffect, useCallback } from 'react';
import { axiosInstance } from '../App';

// Senarai Pakej Langganan (dinamik - diurus oleh superadmin)
// Cache global supaya semua komponen kongsi satu fetch

let cachedPackages = null;
let fetchPromise = null;
const subscribers = new Set();

const FALLBACK = {
  office_hour: { name: 'Office Hour', emoji: '🏢', color: '#9178D6' },
  shift_hour: { name: 'Shift Hour', emoji: '⏰', color: '#7A5FB5' },
};

const notifySubscribers = () => {
  subscribers.forEach((fn) => fn(cachedPackages));
};

const fetchPackages = async () => {
  if (fetchPromise) return fetchPromise;
  fetchPromise = axiosInstance
    .get('/packages')
    .then((res) => {
      cachedPackages = res.data?.packages || [];
      notifySubscribers();
      return cachedPackages;
    })
    .catch(() => {
      cachedPackages = cachedPackages || [];
      notifySubscribers();
      return cachedPackages;
    })
    .finally(() => {
      fetchPromise = null;
    });
  return fetchPromise;
};

export const invalidatePackagesCache = () => {
  cachedPackages = null;
  fetchPackages();
};

const prettify = (code) =>
  (code || '')
    .split('_')
    .map((w) => (w ? w[0].toUpperCase() + w.slice(1) : w))
    .join(' ');

export const usePackages = () => {
  const [packages, setPackages] = useState(cachedPackages || []);
  const [loading, setLoading] = useState(cachedPackages === null);

  useEffect(() => {
    const onUpdate = (pkgs) => {
      setPackages(pkgs || []);
      setLoading(false);
    };
    subscribers.add(onUpdate);

    if (cachedPackages === null) {
      fetchPackages();
    } else {
      setPackages(cachedPackages);
      setLoading(false);
    }

    return () => subscribers.delete(onUpdate);
  }, []);

  // Dapatkan maklumat pakej berdasarkan code (nama dinamik dari superadmin)
  const getPackage = useCallback(
    (code) => {
      if (!code) return null;
      const found = (packages || []).find((p) => p.code === code);
      if (found) return found;
      if (FALLBACK[code]) return { code, ...FALLBACK[code] };
      return { code, name: prettify(code), emoji: '📦', color: '#9178D6' };
    },
    [packages]
  );

  const getPackageName = useCallback((code) => getPackage(code)?.name || '', [getPackage]);
  const getPackageEmoji = useCallback((code) => getPackage(code)?.emoji || '📦', [getPackage]);
  const getPackageColor = useCallback((code) => getPackage(code)?.color || '#9178D6', [getPackage]);

  return { packages, loading, getPackage, getPackageName, getPackageEmoji, getPackageColor };
};

export default usePackages;
